import { BRAND, NAV_LINKS } from "../lib/brand";
import { Instagram, Facebook } from "lucide-react";
import { openExternal } from "../lib/openExternal";

const Footer = () => {
    const handleNav = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <footer
            data-testid="site-footer"
            className="relative bg-navy text-cream pt-20 pb-10 border-t border-gold/20"
        >
            <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center">
                {/* Logo */}
                <div className="flex justify-center">
                    <img
                        src={BRAND.logoMarkGold}
                        alt="Logo Dr. Erik E. Cárdenas Hernández"
                        className="h-24 w-24 object-contain"
                    />
                </div>

                {/* Name + credentials */}
                <div className="mt-6">
                    <p className="font-display text-2xl text-cream">
                        Dr. Erik E. Cárdenas Hernández
                    </p>
                    <p className="mt-2 text-[11px] tracking-[0.28em] uppercase text-gold">
                        YFACS · MASPEN
                    </p>
                </div>

                {/* Especialidades line */}
                <p className="mt-8 text-sm font-light text-cream/70 flex flex-wrap justify-center items-center gap-x-3 gap-y-1">
                    <span>Cirugía General</span>
                    <span className="text-gold">•</span>
                    <span>Laparoscopia Avanzada</span>
                    <span className="text-gold">•</span>
                    <span>Manejo Integral de la Obesidad</span>
                </p>

                {/* Nav links */}
                <nav className="mt-10 flex flex-wrap justify-center gap-x-8 gap-y-3 text-sm">
                    {NAV_LINKS.map((l) => (
                        <button
                            key={l.id}
                            data-testid={`footer-link-${l.id}`}
                            onClick={() => handleNav(l.id)}
                            className="text-cream/70 hover:text-gold transition-colors"
                        >
                            {l.label}
                        </button>
                    ))}
                </nav>

                {/* Social */}
                <div className="mt-10 flex justify-center items-center gap-4">
                    <a
                        data-testid="footer-instagram"
                        href={BRAND.instagram}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                        onClick={(e) => {
                            e.preventDefault();
                            openExternal(BRAND.instagram, BRAND.instagramHandle);
                        }}
                        className="group inline-flex items-center gap-3 px-4 py-2.5 border border-cream/15 hover:border-gold transition-colors"
                    >
                        <Instagram size={16} className="text-gold" strokeWidth={1.5} />
                        <span className="text-[11px] tracking-[0.18em] uppercase text-cream/70 group-hover:text-cream transition-colors">
                            {BRAND.instagramHandle}
                        </span>
                    </a>
                    <a
                        data-testid="footer-facebook"
                        href={BRAND.facebook}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Facebook"
                        onClick={(e) => {
                            e.preventDefault();
                            openExternal(BRAND.facebook, BRAND.facebookHandle);
                        }}
                        className="group inline-flex items-center gap-3 px-4 py-2.5 border border-cream/15 hover:border-gold transition-colors"
                    >
                        <Facebook size={16} className="text-gold" strokeWidth={1.5} />
                        <span className="text-[11px] tracking-[0.18em] uppercase text-cream/70 group-hover:text-cream transition-colors">
                            {BRAND.facebookHandle}
                        </span>
                    </a>
                </div>

                {/* Gold divider */}
                <div className="mt-12 flex items-center justify-center gap-4">
                    <span className="block w-16 h-px bg-gold/40" />
                    <span className="text-[10px] tracking-[0.4em] uppercase text-gold">
                        EC
                    </span>
                    <span className="block w-16 h-px bg-gold/40" />
                </div>

                <p className="mt-8 text-[11px] tracking-[0.2em] uppercase text-cream/45">
                    © {new Date().getFullYear()} Dr. Erik E. Cárdenas Hernández. Todos los derechos reservados.
                </p>
                <p className="mt-2 text-[10px] tracking-[0.18em] uppercase text-cream/35">
                    Cédula Profesional 9536075 · Universidad Anáhuac México Norte
                </p>
                <p className="mt-2 text-[10px] tracking-[0.18em] uppercase text-cream/30">
                    <a
                        href={BRAND.linktree}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:text-gold transition-colors"
                    >
                        linktr.ee/drerikcardenas
                    </a>
                </p>

                {/* QR linktree */}
                <a
                    data-testid="footer-qr-link"
                    href={BRAND.linktree}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-10 inline-flex flex-col items-center group"
                >
                    <span className="bg-cream p-2 border border-gold/40 group-hover:border-gold transition-colors">
                        <img
                            src={BRAND.qrLinktree}
                            alt="Código QR · linktr.ee/drerikcardenas"
                            className="h-24 w-24 object-contain"
                        />
                    </span>
                    <span className="mt-3 text-[10px] tracking-[0.3em] uppercase text-gold/80 group-hover:text-gold transition-colors">
                        Escanea · Linktree
                    </span>
                </a>
            </div>
        </footer>
    );
};

export default Footer;
